<template>
    <div>
        <div class="row" v-if="data != null">
            <div class="col-md-12">
                <button class="btn btn-primary" @click="print.process()">Print</button>
                <div class="card">
                  <div class="card-header card-header-info">
                      <h4 class="card-title ">{{"Voucher '"+data.nama+"'"}}</h4>
                  </div>
                  <div class="card-body">
                      <div class="table-responsive">
                          <table class="table">
                              <thead class=" text-info">
                                  <th width="20px">No.</th>
                                  <th>Paket</th>
                                  <th>Tarif</th>
                                  <th>Status</th>
                                  <th>Print ?</th>
                                  <th>Print Sesi</th>
                              </thead>
                              <tbody>
                              <tr v-for="(ser, index) in data.voucher">
                                  <td>{{ index+1 }}</td>
                                  <td>{{ "#"+ser.id+" "+ser.paket_nama }}</td>
                                  <td>{{ ribu(ser.paket_tarif) }}</td>
                                  <td>
                                      <span v-if="ser.status == 'belum'" class="text-danger">Belum</span>
                                      <span v-else class="text-success">Terpakai</span>
                                  </td>
                                  <td>
                                    <input type="checkbox" :id="ser.id" :value="ser" v-model="data.voucherPrint" v-on:change="print.pilih()"/>
                                  </td>
                                  <td>{{ ser.print_sesi }}</td>
                              </tr>
                              <tr v-if="data.voucher.length == 0">
                                  <td></td>
                                  <td>Tidak ada Data</td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div ref="printVoucher" v-show="false">
          <div style="width:100%;font-family: Arial;float:left">
            <div style="padding: 10px;border: 1px solid #333;float:left" v-for="(ser, index) in print.form.voucherE">
              <strong style="margin-bottom: 5px;display:block">{{"Paket : "+ ser.paket_nama +" #"+ser.id}}</strong>
              <small style="margin: 0;display:block">{{"Username : "+ser.name}}</small>
              <small style="margin: 0;display:block">{{"Password : "+ser.password}}</small>
              <strong style="margin-top: 5px;display:block">{{print.form.namaQ}}</strong>
            </div>
          </div>
        </div> 
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default { 
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
        voucher: [],
        voucherPrint: [],
        id: '',
        nama: ''
    })
    const detail = {
      form : reactive({
        alert: null,
        alertSuccess: null
      }),
      get() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            subadmin: data.nama,
            status: "all",
            dari: null,
            sampai: null
        }
        
        var apiUrl = inter.voucherList();
        myGlobal.call(datax,apiUrl).then(x => {
            //myGlobal.loger(x);
            if (x.status == true) {
                data.voucher = x.data;
            } else {
            //alert(x.pesan);
            }
        })
      }
    }
    const print = {
      form : reactive({
        idPilih: "",
        voucherE: [],
        template: "",
        bro: null,
        namaQ: ''
      }),
      pilih() {       
        var datax = data.voucherPrint;
        var i;
        var idPilihe = null;
        for (i = 0; i < datax.length; i++) {
          if (idPilihe == null) {
            idPilihe = datax[i]["id"];
          } else {
            idPilihe = idPilihe +","+ datax[i]["id"];
          }
        }

        this.form.idPilih = idPilihe;
        this.form.voucherE = datax;
      },
      update() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            id: this.form.idPilih
        }
        
        var apiUrl = inter.updateVoucherPrint();
        myGlobal.call(datax,apiUrl).then(x => {
            //myGlobal.loger(x);
            if (x.status == true) {
              location.href = "#/kang-voucher/"
            } else {
            //alert(x.pesan);
            }
        })
      },
      process() {
        if (this.form.idPilih == "") {
          alert("Pilih Voucher terlebih dahulu");
          return false;
        }
        let divToPrint = this.form.bro.$refs.printVoucher.innerHTML;

        var newWin=window.open('','Print-Window');

        newWin.document.open();

        newWin.document.write('<html><style>@page {size: 45mm;margin: 0mm 0mm 0mm 0mm;}</style><body style="width:210mm;">'+divToPrint+'</body></html>');

        newWin.print();

        newWin.document.close();

        setTimeout(function(){newWin.close();},10);

        this.update();
      }
    }
    return {
      data,
      myGlobal,
      detail,
      print
    }
  },
  mounted () {
    document.title = "Rincian Kang Voucher";

    this.print.form.namaQ = sessionStorage.getItem('admin');

    this.print.form.bro = this;

    this.data.id = this.$route.params.id;
    this.data.nama = this.$route.params.nama;

    if (sessionStorage.getItem('VoucherNama')) {
        this.data.nama = sessionStorage.getItem('VoucherNama');
    } else {
        sessionStorage.setItem('VoucherNama', this.$route.params.nama);
    }

    this.detail.get();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/kang-voucher/detail/voucher.vue